import React, {Component} from 'react';
import copy from 'copy-to-clipboard';
import '../css/copy-to-clipboard.less';
import '../../social/css/index.less';


class CopyToClipboard extends Component {

  static defaultProps = {
      utm_source: "hp",
      utm_medium: "organic",
      utm_campaign: "share_article",
      utm_content: "social_sharing_button"
  }

  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    }
  }


  copyText = (text) => {
    copy(text);
    this.setState({
      clicked: true,
    });
    setTimeout(() => {
      this.setState({
        clicked: false,
      });
    }, 500);
  }



  render() {

    const {title=null, utm_source, utm_medium, utm_campaign, utm_content} = this.props;
    const {clicked} = this.state;

    const location = typeof window !== 'undefined' ? window.location.href: '';
    const link = location + '?utm_source=' + utm_source + '&utm_medium=' + utm_medium + '&utm_campaign=' + utm_campaign + '&utm_content=' + utm_content;

    return (
      <div className="copy-to-clipboard-btn" onClick={() => this.copyText(link)} >
        <div className="share-action-button">
          <img className="link-icon" alt={title ? "Copy the link to share " + title : "Copy the link"} title={title ? "Copy the link to share " + title : "Copy the link"}/>
        </div>
        <div className={"copy-to-clipboard-dialog " + (clicked ? "active" : "hide")}>Copied link!</div>
      </div>
    );
  }

}

export default CopyToClipboard;
